import { UseQueryResult } from "@tanstack/react-query";

import OverviewContentTabs from "./OverviewContentTabs";
import PromptVersionLogsSearchProvider from "./PromptVersionLogsSearchProvider";

import { PromptVersion } from "@/types";

interface OverviewContentProps {
  promptVersion: UseQueryResult<PromptVersion>;
  versionId?: string;
  totalVersions: number;
  navigateToPlayground: () => void;
  onEvaluate: () => void;
  isEvaluateDisabled: boolean;
  setShowVersions: (showVersions: boolean) => void;
  showVersions: boolean;
}

const OverviewContent = ({
  promptVersion,
  totalVersions,
  navigateToPlayground,
  onEvaluate,
  isEvaluateDisabled,
  setShowVersions,
  showVersions,
}: OverviewContentProps) => {
  const isSnippet = promptVersion.data?.is_snippet ?? false;

  return (
    <PromptVersionLogsSearchProvider enabled={!isSnippet}>
      <OverviewContentTabs
        promptVersion={promptVersion}
        totalVersions={totalVersions}
        navigateToPlayground={navigateToPlayground}
        onEvaluate={onEvaluate}
        isEvaluateDisabled={isEvaluateDisabled}
        setShowVersions={setShowVersions}
        showVersions={showVersions}
      />
    </PromptVersionLogsSearchProvider>
  );
};

export default OverviewContent;
